import axios from 'axios'
// import { config } from '../config'

// axios.defaults.baseURL = config.backendURL
axios.defaults.headers.post['Content-Type'] = 'application/json'
// axios.defaults.headers.get['Access-Control-Allow-Origin'] = true

/**
 * Set Authorization header for requests
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
export const setAuthToken = (token) => {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
 export const request = (options) => {
    // console.log(options)
    return axios(options).then(res => res)
    .catch(err => err.response)
}

// export const request = (options) => {
//     // console.log(options)
//     // console.log(options.token)
//     const url = options.url
//     return axios.get(
//         url, 
//         {
//             headers: {
//                 Authorization : "Bearer " + options.token,
//             }
//         }
//     ).then(res => res)
//     .catch(err => err.response)
// }
